import { useFirebase } from 'components/Firebase/index.js';
import useOrgId from './useOrgId.js';
import { useMutation, useQueryClient } from 'react-query';

const useUpdateVodSettingsMutation = ({ onSuccess, ...options } = {}) => {
  const orgId = useOrgId();
  const firebase = useFirebase();
  const queryClient = useQueryClient();
  const endPointUrl = `/o/${orgId}/settings/vod`;

  return useMutation({
    mutationFn: async (updates) => {
      if (!orgId) return;
      const agent = await firebase.getAgent();
      return agent.patch(endPointUrl).send(updates);
    },
    onSuccess: (data, variables, contexts) => {
      queryClient.invalidateQueries(['vod-settings', orgId]);
      onSuccess?.(data, variables, contexts);
    },
    ...options,
  });
};

export default useUpdateVodSettingsMutation;
